import { AxiosError } from "axios";
import { UseQueryResult, useQuery } from "react-query";
import { StrapiQueryOutcomesResponse } from "../model/QueryInbox";
import {
  StrapiCMSPromiseType,
  StrapiCMSApiService,
  StrapiFilter,
} from "../../../help-center/service/api/StrapiCMSApiService";
import { QueryCategory } from "../../utils/types";

interface QueryOutcomesParams {
  category?: QueryCategory;
}

const useGetQueryOutcomesDataService = (
  params?: QueryOutcomesParams
): UseQueryResult<StrapiQueryOutcomesResponse, AxiosError> => {
  const filters: StrapiFilter | undefined = params?.category
    ? { Category: { $eq: params.category } }
    : undefined;

  return useQuery<
    Promise<StrapiCMSPromiseType>,
    AxiosError,
    StrapiQueryOutcomesResponse
  >(["QueryOutcomesCMSData", params?.category], () =>
    StrapiCMSApiService("query-outcomes", undefined, undefined, filters)
  );
};

export default useGetQueryOutcomesDataService;
